import { BrandsScreen } from './brands-screen'
import { useBrandsQuery } from './queries'

export const BrandsScreenContainer = () => {
  const { data, loading } = useBrandsQuery()

  const brands = data?.Brands?.docs?.map((brand) => ({
    id: brand.id,
    title: brand.name,
    href: `/discounts/${brand.slug}`,
    image: brand.logo?.url,
    slug: brand.slug,
  }))

  return <BrandsScreen brands={brands || []} loading={loading} />
}
